// The single-player room: @taxwar/room-local running in a dedicated Worker (docs/ARCHITECTURE.md §1, §14).

import RoomWorker from '@taxwar/room-local/worker?worker'
import { PostMessageSocket } from './post-message-socket'
import { connectLocalRoom, type LocalRoomConnection } from './room-connection'

/** RpcClient requires a URL; the Worker transport has none. */
const LOCAL_ROOM_URL = 'worker://room-local'
const ROOM_WORKER_NAME = 'taxwar-room'

/** Spawns a fresh room Worker; LocalRoomConnection.dispose() terminates it. */
export function createLocalRoom(): Promise<LocalRoomConnection> {
  return connectLocalRoom(LOCAL_ROOM_URL, () => new PostMessageSocket(new RoomWorker({ name: ROOM_WORKER_NAME })))
}
